import { useMutation } from "@tanstack/react-query";
import { CreateClientRequest } from "@/Stub/V1";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";
import { ClientsApiClient } from "@/Service/Api/V1/ApiClients/ClientsApiClient";

export const useCreateClient = () =>
    useMutation({
        mutationFn: async (data: CreateClientRequest) => {
            try {
                return await ClientsApiClient.createClient(data);
            } catch (error) {
                await processValidationErrors(error);
                throw error;
            }
        }
    });
